const roles = {
  superAdmin: 'superadmin',
  orgAdmin: 'organizationadmin',
  orgEmployee: 'organizationemployee',
  memberCare: 'membercare',
  peerSupport: 'peersupport',
  peerSupportLead: 'peersupportlead',
  contentCreator: 'contentcreator',
}

export default roles;